import PowerSettingsNewTwoToneIcon from '@mui/icons-material/PowerSettingsNewTwoTone';
import {
	AppBar,
	IconButton,
	Menu,
	MenuItem,
	Toolbar,
	Typography,
} from "@mui/material";
import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/auth.actions";
import styles from "../CSS/HeaderSideNav.module.css"

const Header = () => {
	const { isAuthenticated, loading, admin } = useSelector(
		(state) => state.authReducer
	);
	const navigate = useNavigate();

	const dispatch = useDispatch();

	const handleClick = () => {
		dispatch(logout());
		navigate("/login");
	};
	const authLinks = (
		<div style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem"}}>
			<p> Welcome, { admin && admin.name.toUpperCase() } </p>
			<PowerSettingsNewTwoToneIcon style={{cursor: "pointer"}} onClick={ handleClick } />
		</div>
	);
	return (
		<AppBar
			position='fixed'
			sx={ { zIndex: (theme) => theme.zIndex.drawer + 1 } }
			className={ styles.header }>
			<Toolbar>
				<Typography
					variant='h6'
					noWrap
					component='a'
					href='/'
					sx={ {
						fontFamily: "Comfortaa",
						fontSize: "1.5vw",
						color: "#f9f7f7",
						display: { xs: "none", md: "flex" },
						fontWeight: 700,
						textDecoration: "none",
					} }>
					plutosONE
				</Typography>
				<Typography
					sx={ { ml: "34%", mt: 1, flex: 1, color: "#f9f7f7" } }
					noWrap
					variant='overline'
					component='div'>
					Engagement Management System
				</Typography>
				<Fragment>{ isAuthenticated && authLinks }</Fragment>
			</Toolbar>
		</AppBar>
	);
};

export default Header;
